/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import '../../common/challenge/start_challenge';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "bbfrontend": {
        "nested": {
          "dashboard": {
            "nested": {
              "challenge": {
                "nested": {
                  "DashboardWebChallengeService": {
                    "methods": {
                      "StartChallenge": {
                        "requestType": ".squareup.bbfrontend.common.challenge.StartChallengeRequest",
                        "responseType": ".squareup.bbfrontend.common.challenge.StartChallengeResponse"
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.bbfrontend?.nested?.dashboard?.nested?.challenge?.nested?.DashboardWebChallengeService) {
  $root.addJSON(jsonData);
}

/**
 * SOURCE DashboardWebChallengeService @ squareup/bbfrontend/dashboardweb/challenge/challenge_service.proto at 12:1
 */
export const DashboardWebChallengeService = $root.lookupService('squareup.bbfrontend.dashboard.challenge.DashboardWebChallengeService');